module.exports = __webpack_public_path__ + "static/media/book.0520567f.png";